import type { AnyFieldApi } from '@tanstack/react-form';
import type { ChangeEventHandler } from 'react';
import type { InputProps } from '../../../components/Input/Input';

import { useCallback, useMemo } from 'react';

import Input from '../../../components/Input/Input';

interface FormInputProps extends InputProps {
  field: AnyFieldApi;
}

const FormInput = ({ field, ...props }: FormInputProps) => {
  const onChange = useCallback<ChangeEventHandler<HTMLInputElement>>(
    (e) => {
      field.handleChange(e.target.value);
    },
    [field],
  );

  const errors = useMemo(() => {
    if (!field.state.meta.isTouched) return;
    return field.state.meta.errors.map((error) =>
      typeof error === 'string' ? error : error.message,
    );
  }, [field.state.meta.errors, field.state.meta.isTouched]);

  return (
    <Input
      {...props}
      name={field.name}
      value={field.state.value}
      onChange={onChange}
      onBlur={field.handleBlur}
      error={errors}
    />
  );
};
export default FormInput;
